import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const UnStyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  -webkit-user-drag: none;
`
